// Port of ios/Sources/Resources/EmojiCharacters.swift — the shortcode → glyph table.
//
// The table itself is GENERATED (scripts/gen-emoji.mjs → generated/emojiCharacters.json) from
// the webapp's own emoji table, the same source as Apple's EmojiCharacters.swift and Android's
// EmojiUnicodeNames.kt. Do not edit the JSON by hand.

import table from './generated/emojiCharacters.json';

const byName: Readonly<Record<string, string>> = table as Record<string, string>;

/** The shortcode's glyph, or null for a custom emoji this table cannot draw. */
function character(name: string): string | null {
  return Object.prototype.hasOwnProperty.call(byName, name) ? byName[name] : null;
}

export const EmojiCharacters = {
  byName,
  character,
} as const;
